import React from "react";
import { Button } from "@components/library";
import { useTranslation } from "@helpers/translate";
import { PROFILE_VERIFICATION_PAGE } from "@constants";
import IntroHeaderIcon from "@assets/icons/IntroHeaderIcon";
import ArrowRightIcon from "@assets/icons/ArrowRightIcon";

import "./Intro.sass";

export const ProfileVerificationIntro = () => {
  const { __, __raw } = useTranslation();

  const toList = (value) => (Array.isArray(value) ? value : []);
  const escapeRegExp = (str) =>
    String(str).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const privileges = toList(__raw("verification.home.privileges"));
  const descriptions = toList(__raw("verification.home.description"));

  return (
    <div className="pv-intro">
      <div className="pv-intro__wrapper">
        <div className="pv-intro__header">
          <span className="pv-intro__icon">
            <IntroHeaderIcon className="pv-intro__icon-svg" />
          </span>
          <div>
            <h2 className="pv-intro__title">{__("verification.home.header")}</h2>
            {privileges.length > 0 && (
              <ul className="pv-intro__header-list">
                {privileges.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="pv-intro__content">
          {descriptions.length > 0 && (
            <ul className="pv-intro__content-list">
              {descriptions.map((item, idx) => {
                const highlightWords = [
                  "ID Card",
                  "Driving Licence",
                  "Passport",
                ];

                const parts = String(item).split(
                  new RegExp(
                    `(${highlightWords.map(escapeRegExp).join("|")})`,
                    "gi",
                  ),
                );

                return (
                  <li key={idx}>
                    {parts.map((part, i) =>
                      highlightWords.some(
                        (w) => w.toLowerCase() === part.toLowerCase(),
                      ) ? (
                        <span key={i} className="pv-intro__highlight">
                          {part}
                        </span>
                      ) : (
                        part
                      ),
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>

      <div className="pv-intro__buttons">
        <Button
          type="link"
          to={`${PROFILE_VERIFICATION_PAGE}/personal-information`}
          color="orange"
          size="middle"
        >
          {__("verification.buttons.start")}
          <ArrowRightIcon />
        </Button>
      </div>
    </div>
  );
};

export default ProfileVerificationIntro;
